import { render, staticRenderFns } from "./position-performance-templates.vue?vue&type=template&id=5078c695"
import script from "./position-performance-templates.vue?vue&type=script&lang=js"
export * from "./position-performance-templates.vue?vue&type=script&lang=js"
import style0 from "./position-performance-templates.vue?vue&type=style&index=0&id=5078c695&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports